import React from 'react';

import CallListingShape from 'app/shapes/CallListingShape';

import CallButton from 'app/components/shared/CallButton';
import ListenButton from 'app/components/shared/ListenButton';
import SendMailButton from 'app/components/shared/SendMailButton';
import SendTextButton from 'app/components/shared/SendTextButton';
import { navigateTo } from 'app/util/navigation';

const ListingButton = ({ listing }) => {
  const mailUrl = `/messages/compose?message%5Brecipients_list%5D=${listing?.login}`;
  const chatUrl = `/chat/${listing?.advisor_slug}`;
  const listingUrl = `/call/listing/${listing.id}`;

  const isBusy = listing.advisor_busy;
  const isAvailable = listing.advisor_availability === 1;
  const canText = listing.can_text;

  let button;
  if (listing?.recorded) {
    button = (
      <ListenButton
        onClick={() => { navigateTo(listingUrl); }}
        href={listingUrl}
      />
    );
  } else if (isBusy) {
    button = (
      <SendMailButton
        status="busy"
        onClick={() => navigateTo(mailUrl)}
        href={mailUrl}
      />
    );
  } else if (isAvailable) {
    button = (
      <CallButton
        onClick={() => { navigateTo(listingUrl); }}
        href={listingUrl}
      />
    );
  } else if (canText) { // implies !busy && !isAvailable
    button = (
      <SendTextButton
        onClick={() => navigateTo(chatUrl)}
        href={chatUrl}
      />
    );
  } else { // implies !busy && !isAvailable && !canText
    button = (
      <SendMailButton
        status="away"
        onClick={() => navigateTo(mailUrl)}
        href={mailUrl}
      />
    );
  }

  return button;
};

ListingButton.propTypes = {
  listing: CallListingShape.isRequired,
};

export default ListingButton;
